import React from 'react'
import styled from 'styled-components'

import { Box, Button } from '@usap/uicomponents'


const borderColor = props => props.theme.global.colors['background-back'];
const dividerColor = props => props.theme.global.colors['light-3'];
const whiteColor = props => props.theme.global.colors['white'];
const trackButtonColor = props => props.theme.global.colors['text'];

export const Container = styled(Box)`
  background: ${whiteColor};
  border: solid 1px ${borderColor};
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 16px;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    padding: 24px;
  }
`

export const ResponsiveContainer = styled(Box)`
  flex-direction: column;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const OrderStatusContainer = styled(Box)`
  background: ${borderColor};
  border-radius: 4px;
  padding: 12px;
  gap: 4px;
`

export const OrderItemBox = styled(Box)`
  width: 100%;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 65%;
  }
`

export const OrderDetailsBox = styled(Box)`
  padding-bottom: 0px;
  flex-direction: row;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    // padding-bottom: 8px;
  }
`

export const Divider = styled.div`
  border: 0.5px solid ${dividerColor};
  margin: 0px 32px;
`

export const OrderDetailsTextBox = styled(Box)`
  // width: 65%;
  padding: 8px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    // width: 80%;
  }
`

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  flex: 1;
`

export const ActionTrackContainer = styled.div`
  width: 100%;
`

export const DesktopKitContainer = styled(Box)`
  display: none;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    display: inherit;
    
  }
`
export const MobileKitContainer = styled(Box)`
  display: inherit;
  margin-bottom: 24px;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    display: none;
  }
`



export const CorePriceContainer = styled(Box)`
  position: relative;
  flex-direction: row;
`

export const TrackItemButton = styled(Button)`
  width: 100%;
  height: 40px;
  background-color: ${trackButtonColor};
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: ${trackButtonColor};
    border: none;
  }
`
export const ProductImageContainer = styled(Box)`
  gap: 12px;
`
export const QuantityContainer = styled(Box)`
  border-radius: 4px;
  background: ${borderColor};
  align-items: center;
  padding: 4px;
`

export const ProductProtectionMainSection = styled(Box)`
  flex-direction: column;
  gap: 24px;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: row;
    justify-content: flex-start;
    gap: 0;
  }
`;

export const ProductProtectionDescription = styled(Box)`
  width: 100%;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 65%;
    padding-left: 116px;
  }
`